"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const payments_1 = require("../../payments");
const quote_1 = require("../../quote");
const date_fns_1 = require("date-fns");
const __1 = require("..");
const insuranceCertificatePurchaseRequest_1 = __importDefault(require("../../certificate/insuranceCertificatePurchaseRequest"));
class InsuranceCertificateQuoteRequest extends insuranceCertificatePurchaseRequest_1.default {
    constructor(user, coverage, assured, shipment, channel, quoteStatus = __1.eQuoteStatus.PENDING, quoteRecipient, additionalComments, createdDate, sendEmailsTo, quoteId, shipmentContact, expiredDate, callback, underwriting, accountId) {
        super(user, coverage, assured, shipment, channel, shipmentContact, new payments_1.QuotePaymentMethod(), sendEmailsTo, callback, undefined, undefined, accountId);
        this.quoteStatus = quoteStatus;
        this.quoteRecipient = quoteRecipient;
        this.additionalComments = additionalComments;
        this.createdDate = createdDate;
        this.quoteId = quoteId;
        this.underwriting = underwriting;
        this.expiredDate =
            expiredDate ||
                quote_1.calculateQuoteExpiryDate(this.createdDate, this.shipment.pickupStop).toISOString();
    }
    static create(quoteId, user, coverage, assured, shipment, channel, quoteRecipient, additionalComments, sendEmailsTo, shipmentContact, callback, underwriting, accountId) {
        const createdDate = new Date();
        return new InsuranceCertificateQuoteRequest(user, coverage, assured, shipment, channel, __1.eQuoteStatus.PENDING, quoteRecipient, additionalComments, date_fns_1.formatISO(createdDate), sendEmailsTo, quoteId, shipmentContact, undefined, callback, underwriting, accountId);
    }
    get secondsTillExpiry() {
        const expiryDate = date_fns_1.parseISO(this.expiredDate);
        return date_fns_1.differenceInSeconds(expiryDate, new Date());
    }
}
exports.default = InsuranceCertificateQuoteRequest;
//# sourceMappingURL=insuranceCertificateQuoteRequest.class.js.map